module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_4-46196441020800b5f68e607baab11527.jpg";